import { render, staticRenderFns } from "./DescriptionMaterials.vue?vue&type=template&id=608ce5a8"
import script from "./DescriptionMaterials.vue?vue&type=script&lang=js"
export * from "./DescriptionMaterials.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports